import { useLanguage } from "@/i18n/LanguageContext";

interface HeroSectionProps {
  zips: string[];
  h1: string;
  paragraph: string;
}

export default function HeroSection({ zips, h1, paragraph }: HeroSectionProps) {
  const { t } = useLanguage();
  return (
    <section className="bg-[#fefce8] min-h-[60vh] flex items-center">
      <div className="max-w-7xl mx-auto px-6 py-16 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-10 items-center">
          <div className="lg:col-span-3">
            <span className="inline-block text-[#ea580c] text-sm font-black uppercase tracking-widest mb-4">
              {zips.join(" · ")}
            </span>
            <h1 className="text-[#1a1a1a] text-4xl md:text-5xl font-black leading-tight mb-6">
              {h1}
            </h1>
            <p className="text-[#444444] text-base md:text-lg leading-relaxed mb-8 max-w-xl">
              {paragraph}
            </p>
            <div className="flex flex-wrap gap-4">
              <a
                href="tel:+17863774452"
                className="inline-flex items-center gap-2 bg-[#047857] text-white px-6 py-3 text-sm font-bold rounded-none hover:bg-[#065f46] transition-colors whitespace-nowrap"
              >
                <i className="ri-phone-line" />
                {t("hood.callNow")}
              </a>
              <a
                href="#final-cta"
                className="inline-flex items-center gap-2 border-2 border-[#047857] text-[#047857] px-6 py-3 text-sm font-bold rounded-none hover:bg-[#047857] hover:text-white transition-colors whitespace-nowrap"
              >
                <i className="ri-calendar-check-line" />
                {t("hood.getQuote")}
              </a>
            </div>
          </div>
          <div className="lg:col-span-2">
            <div className="w-full h-[300px] md:h-[400px] overflow-hidden rounded-none">
              <img
                src="https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/9ef0a52e93d9d779fa183f9e9fc74c67.jpeg"
                alt="Brickell Miami window repair high-rise condo service"
                className="w-full h-full object-cover"
                onError={(e) => {
                  (e.target as HTMLImageElement).style.backgroundColor = "#064e3b";
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}